import { apiService } from '@/services/APIService';

export default {
  createTag(params) {
    return apiService.post('/moderation-tags', params);
  },
  showTag(id) {
    return apiService.get(`/moderation-tags/${id}`);
  },
  showTags(params) {
    return apiService.get('/moderation-tags', params);
  },
  updateTag(id, params) {
    return apiService.put(`/moderation-tags/${id}`, params);
  },
  deleteTag(id) {
    return apiService.delete(`/moderation-tags/${id}`);
  },
  attachUsersToTag(id, params) {
    return apiService.post(`/moderation-tags/${id}/attach-users`, params);
  },
  attachEventsToTag(id, params) {
    return apiService.post(`/moderation-tags/${id}/attach-events`, params);
  },
  detachUsersFromTag(id, params) {
    return apiService.post(`/moderation-tags/${id}/detach-users`, params);
  },
  detachEventsFromTag(id, params) {
    return apiService.post(`/moderation-tags/${id}/detach-events`, params);
  },
  showModerators(params) {
    return apiService.get('/user/moderators', params);
  },
  createModerator(params) {
    return apiService.post('/user/moderators', params);
  },
  deleteModerator(id, params) {
    return apiService.delete(`/user/moderators/${id}`, params);
  },
};
